<template>
  <section class="hero">
    <div class="hero-body">
      <div class="container">
        <h1 class="title">Film visti</h1>
        <b-modal :active.sync="showMovieDetails" :width="800">
            <movie-details :movie-data="movieDetails" 
            @MovieDetailsDelete="doDelete"
            @MovieDetailsEdit="doEdit"
            @MovieDetailsAsinello="doAsinello"
            />
          </b-modal>
        <b-tabs v-model="selectedTab">

          <b-tab-item label="Visioni">
            <div style="cursor:pointer">
              <b-table
                :data="rowData"
                :columns="columns"
                :striped="true"
                :paginated="true"
                :per-page="10"
                :total="total"
                :hoverable="true"
                :current-page.sync="page"
                :pagination-simple="false"
                :selected.sync="selected"
                :backend-pagination="true"
                 :backend-filtering="true"
                @filters-change="filtersChange"
                @select="select"
                @click="rowClicked"
                @page-change="onPageChange"

              >
                <b-input
                  slot="searchable"
                  slot-scope="props"
                  v-model="props.filters[props.column.field]"
                  placeholder="Cerca..."
                  icon="magnify"
                  size="is-small"
                />
            </b-table>
            </div>
             <section>
                  <div class="buttons">
                    <b-button @click="doNew" type="is-primary" >Nuovo</b-button>
                    <b-button @click="doClearSearch" type="is-primary"
            >Mastrolindo</b-button
          >
                  </div>
                </section>
          </b-tab-item>

          <b-tab-item :disabled="true" label="Dettagli">
            <h1 class="title">
              {{ vShow.Movie_original_title }}, {{ vShow.Movie_year }}
            </h1>
            <h2 class="subtitle">di {{ vShow.directors_string }}</h2>
            <div class="columns">
              <div class="column is-half">
                <b-field label="Titolo">
                  <b-input
                    ref="iTitolo"
                    v-model="vShow.Movie_title"
                    required
                    validation-message="Obbligatorio!"
                     tabindex=1
                  ></b-input>
                </b-field>
                <b-field label="Titolo originale">
                  <b-input
                    ref="iTitoloOr"
                    v-model="vShow.Movie_original_title"
                    required
                    validation-message="Obbligatorio!"
                     tabindex=2
                  ></b-input>
                </b-field>
                <b-field label="Anno">
                  <b-input
                    ref="iAnno"
                    v-model="vShow.Movie_year"
                    type="number"
                    min="1800"
                    max="2100"
                    validation-message="Mettici un numero buono!"
                     tabindex=3
                  ></b-input>
                </b-field>
                
                 <b-field label="Voto">
                  <star-rating
                    v-model="vShow.Dicks"
                    :show-rating="false"
                    :increment="0.5"
                    :star-size="30"
                  />
                </b-field>
                <section>
                  <div class="buttons">
                    <b-button @click="doSave" type="is-primary">Vai</b-button>
                    <b-button @click="doCancel" type="is-primary"
                      >Naaah</b-button
                    >
                  </div>
                </section>
              </div>
              <div class="column">
                <b-field label="Data Fine Visione">
                  <b-datepicker
                    ref="iDateSeen"
                    v-model="vShow.Date_seen"
                    editable
                    :date-formatter="isoDate"
                    required
                    validation-message="Obbligatorio!"
                  >
                  </b-datepicker>
                </b-field>
               <b-field label="Città">
                  <b-select
                    ref="iCity"
                    v-model="vShow.City_id"
                    @input="citySelected"
                    required
                    validation-message="Obbligatorio!"
                    
                  >
                    <option
                      v-for="city in lovs.cities"
                      :value="city.Id"
                      :key="city.Id"
                    >
                      {{ city.City }}
                    </option>
                  </b-select>
                </b-field>
                <b-field label="Modalità">
                  <b-select
                    v-model="vShow.Mode_id"
                    @input="modeSelected"
                    ref="iMode"
                    required
                    validation-message="Obbligatorio!"
                  >
                    <option
                      v-for="mode in lovs.modes"
                      :value="mode.Id"
                      :key="mode.Id"
                    >
                      {{ mode.Mode }}
                    </option>
                  </b-select>
                </b-field>
                <b-field label="Servizio" v-show="showServices">
                  <b-select ref="iService" v-model="vShow.Service_id">
                    <option
                      v-for="service in lovs.active_services"
                      :value="service.Id"
                      :key="service.Id"
                    >
                      {{ serviceName(service) }}
                    </option>
                  </b-select>
                </b-field>
                <b-field label="Lingua">
                  <b-select
                    v-model="vShow.Language_id"
                    ref="iLanguage"
                    required
                    validation-message="Obbligatorio!"
                  >
                    <option
                      v-for="lng in lovs.languages"
                      :value="lng.Id"
                      :key="lng.Id"
                    >
                      {{ lng.Language }}
                    </option>
                  </b-select>
                </b-field>
                <label class="label">Amici</label>
                <div class="tagsection">
                <b-taginput
                v-model="vShow.Friends"
                :data="filteredFriends"
                autocomplete
                :allow-new="false"
                :open-on-focus="false"
                field="Friend"
                icon="label"
                placeholder="Amici..."
                @typing="getFilteredFriends">
                
            </b-taginput>
            </div> 
            <label class="label">Reazioni & Tag</label>
            <div class="tagsection">
             <b-taginput
                v-model="vShow.Reactions"
                :data="filteredReactions"
                autocomplete
                :allow-new="false"
                :open-on-focus="false"
                field="Tag"
                icon="label"
                placeholder="Reazioni..."
                @typing="getFilteredReactions">
            </b-taginput>
            </div>
            <div class="tagsection">
                <b-taginput
                v-model="vShow.Tags"
                :data="filteredTags"
                autocomplete
                :allow-new="false"
                :open-on-focus="false"
                field="Tag"
                icon="label"
                placeholder="Tag..."
                @typing="getFilteredTags">
            </b-taginput>
            </div>
            
            <b-field label="Commenti">
              <b-input  type="textarea"  v-model="vShow.Comment"></b-input>
            </b-field>
                <section>
                  <div class="buttons"></div>
                </section>
              </div>
            </div>
          </b-tab-item>
          <b-tab-item label="Aggiungi">
            <add-vision @OkSearchImdb="doOkImdb" />
          </b-tab-item>
          <b-tab-item label="Ricerca" ref="form">
            <search-vision @OkSearch="doOkSearch" />
          </b-tab-item>
        </b-tabs>
      </div>
    </div>
  </section>
</template>

<script>
import api from "../api/api.js";
import helpers from "../helpers.js";

import SearchVision from "@/components/SearchVision";
import AddVision from "@/components/AddVision";
import MovieDetails from "@/components/MovieDetails"
import StarRating from "vue-star-rating";

let emptyVal = { id: 0, Dicks: 0 };

export default {
  name: "vision",
  components: { SearchVision, AddVision, StarRating, MovieDetails },
  methods: 
  
  {
    filtersChange(filter) {
      this.filter=filter;
      this.getData();
      this.getTotal();
    },
    getFilteredTags(text) {
      this.filteredTags = this.lovs.tags.filter((option) => {
          return option.Tag
              .toString()
              .toLowerCase()
              .indexOf(text.toLowerCase()) >= 0
      })
    },
    getFilteredReactions(text) {
      this.filteredReactions = this.lovs.reactions.filter((option) => {
          return option.Tag
              .toString()
              .toLowerCase()
              .indexOf(text.toLowerCase()) >= 0
      })
    },
    getFilteredFriends(text) {
      this.filteredFriends = this.lovs.friends.filter((option) => {
          return option.Friend
              .toString()
              .toLowerCase()
              .indexOf(text.toLowerCase()) >= 0
      })
    },
    serviceName(service) {
      if (service.Room) return service.Name + " - " + service.Room;
      else return service.Name;
    },
    getData() {
      const loading = this.$buefy.loading.open();
      api.vision
        .getPaginated(
          (this.page - 1) * 10,
          10,
          helpers.buildFilter(this.filter)
        )
        .then((rows) => {
          //this.buildActiveLovs();
          this.rowData = helpers.flattenVisions(rows.data, this.allLovs);
          loading.close();
        })
        .catch((err) => {
              helpers.error("Errore! " + err);
              loading.close();
        });
    },

    buildActiveLovs(data) {
      this.allLovs.languages = data.languages;
      this.lovs.languages = data.languages.filter((x) => {
        return x.Active;
      });
      this.allLovs.services = data.services;
      this.lovs.services = data.services.filter((x) => {
        return x.Active && x.Name !="p2p";
      });
      this.lovs.active_services = [...this.lovs.services];
      this.allLovs.cities = data.cities;
      this.lovs.cities = data.cities.filter((x) => {
        return x.Active;
      });
      this.allLovs.modes = data.modes;
      this.lovs.modes = data.modes.filter((x) => {
        return x.Active;
      });
      this.allLovs.friends = data.friends;
      this.lovs.friends = data.friends.filter((x) => {
        return x.Active;
      });
      this.allLovs.tags = data.tags;
      this.lovs.tags = data.tags.filter((x) => {
        return x.Active && !x.IsReaction;
      });
      this.lovs.reactions = data.tags.filter((x) => {
        return x.Active && x.IsReaction;
      });
     
      helpers.adjLov(
        this.lovs,
        "cities",
        this.vShow.City_id,
        "City",
        data.cities
      );
      helpers.adjLov(
        this.lovs,
        "languages",
        this.vShow.Language_id,
        "Language",
        data.languages
      );
      helpers.adjLov(
        this.lovs,
        "modes",
        this.vShow.Mode_id,
        "Mode",
        data.modes
      );
      this.citySelected(this.vShow.City_id);
      helpers.adjLov(
        this.lovs,
        "services",
        this.vShow.Service_id,
        "Service",
        data.services
      );
      this.showServices = this.vShow.Service_id;

    },
    getTotal() {
      const loading = this.$buefy.loading.open();
      api.vision.getTotal(helpers.buildFilter(this.filter)).then((rows) => {
        this.total = rows.data;
        loading.close();
      });
    },
    modeSelected(value) {
      var selected = this.lovs.modes.filter((x) => {
        return x.Id == value;
      })[0];
      this.showServices =
        selected.Mode == "Cinema" || selected.Mode == "Streaming";
      if (selected.Mode == "Streaming") {
        this.lovs.active_services = this.lovs.services.filter((x) => {
          return x.Active && x.Is_tv && x.Name !="p2p";
        });
      } else if (selected.Mode == "Cinema") {
        this.citySelected(this.vShow.City_id);
      }
    },
    citySelected(value) {
      var selectedMode = this.lovs.modes.filter((x) => {
        return x.Id == this.vShow.Mode_id;
      })[0];
      if (!selectedMode) return;
      if (selectedMode.Mode == "Cinema") {
        this.lovs.active_services = this.lovs.services.filter((x) => {
          return x.Active && x.City_id == value && !x.Is_tv ;
        });
      }
    },
    isoDate(date) {
      return helpers.buildIsoDate(date);
    },
    doDelete() {
      this.$buefy.dialog.confirm({
        message: "Lo scancello sul serio?",
        onConfirm: () => {
          const loading = this.$buefy.loading.open();
          api.vision
            .delete(this.movieDetails.row.Id)
            .then(() => {
              this.getData();
              this.getTotal();
              helpers.ok("Visione correttamente scancellata");
              this.vShow = {};
              this.showMovieDetails = false;
              loading.close();
            })
            .catch((err) => {
              helpers.error("Errore! " + err);
              loading.close();
            });
        },
      });
    },
    doOkImdb(imdbData) {
      this.vShow = imdbData.Ext_show;
      this.vShow.Directors = imdbData.Directors;
      this.selectedTab = 1;
    },
    doCancel() {
      this.vShow = {};
      this.selectedTab = 0;
    },
    doOkSearch(filterModel) {
      this.filter = filterModel;
      this.selectedTab = 0;
      this.getData();
      this.getTotal();
    },
    doClearSearch() {
      this.doOkSearch({});
    },
    doNew() {
      this.selectedTab = 2;
    },
    doSave() {
      if (
        !this.$refs["iTitolo"].checkHtml5Validity() ||
        !this.$refs["iTitoloOr"].checkHtml5Validity() ||
        !this.$refs["iAnno"].checkHtml5Validity() ||
        !this.$refs["iDateSeen"].checkHtml5Validity() ||
        !this.$refs["iCity"].checkHtml5Validity() ||
        !this.$refs["iLanguage"].checkHtml5Validity() ||
        !this.$refs["iMode"].checkHtml5Validity()
      ) {
        helpers.error("C'è qualcosa che non va nelle validazioni!");
        return;
      }
      if (!this.vShow.Dicks) {
        helpers.error("Ti sei scordato il voto!");
        return;
      }
      if (this.showServices && !this.vShow.Service_id) {
        helpers.error("Ti tocca metterci il servizio");
      }
      let apiMethod = this.vShow.Id ? api.vision.update : api.vision.create;
      const loading = this.$buefy.loading.open();
      apiMethod(this.vShow)
        .then(() => {
          this.getData();
          this.getTotal();
          this.vShow = {};
          this.selectedTab = 0;
           loading.close();
        })
        .catch((err) => {
          helpers.error("Errore! " + err);
           loading.close();
        });
    },
    doEdit() {
      this.vShow = this.movieDetails.row.Ext_show;
      this.vShow.Friends = this.movieDetails.Friends
      this.vShow.Tags = this.movieDetails.Tags
      this.vShow.Reactions = this.movieDetails.Reactions
      this.vShow.Date_seen = new Date(helpers.buildDate(this.vShow.Date_seen));
      this.vShow.directors_string = this.movieDetails.directors_string;
      this.showMovieDetails = false;
      this.selectedTab=1;
    },
    doAsinello() {
      
      let as_data = {};
      as_data.Id = this.movieDetails.row.Id;
      as_data.Dicks = this.movieDetails.row.Dicks;
      as_data.Date_seen = this.movieDetails.row.Date_seen;
      as_data.Movie_title = this.movieDetails.row.Ext_show.Movie_title;
      as_data.Movie_directors = this.movieDetails.directors_string;
      as_data.Movie_original_title = this.movieDetails.row.Ext_show.Movie_original_title;
      as_data.Movie_year = this.movieDetails.row.Ext_show.Movie_year;
      as_data.Movie_tmdb_id = this.movieDetails.row.Ext_show.Movie_tmdb_id;
      as_data.Movie_imdb_id = this.movieDetails.row.Ext_show.Movie_imdb_id;
      as_data.Comment = this.movieDetails.row.Comment;
      as_data.TmdbTagline = this.movieDetails.tmdb.tagline;
      as_data.TmdbSummary = this.movieDetails.tmdb.overview;
      as_data.Movie_poster = this.movieDetails.tmdb.poster_path;
      console.warn(this.movieDetails);
      as_data.Tags = this.movieDetails.Tags.map((x) => "'"+x.Tag+"'").join(",");
      as_data.Reactions = this.movieDetails.Reactions.map((x) => "'"+x.Tag+"'").join(",");
      console.log(as_data);
      const loading = this.$buefy.loading.open();
      api.vision.asinello(as_data)
        .then(() => {
        helpers.ok("Scaricato l'asinello del film!");
           loading.close();
        })
        .catch((err) => {
          helpers.error("Errore! " + err);
           loading.close();
        });
    },
    rowClicked(row) {
      const loading = this.$buefy.loading.open();
      api.tmdb
        .getMovie(row.Ext_show.Movie_tmdb_id)
        .then((movie) => {
          this.movieDetails = { row: row, tmdb: movie.data };
          this.movieDetails.genre_string = movie.data.genres
            .map((x) => x.name)
            .join("/");
          return api.friend.getByShow(row.Ext_show.Id)
        })
        .then ((friends)=>{
          this.movieDetails.Friends = friends.data;
          this.movieDetails.friend_string = friends.data.length>0? 
           ( "con " + friends.data.map((x) => x.Friend)
            .join(", ")):" da solo";
          return api.tag.getByShow(row.Ext_show.Id);
        })
         .then ((tags)=>{
          this.movieDetails.Tags = tags.data.filter((x) => {
              return !x.IsReaction;
          });
          this.movieDetails.Reactions = tags.data.filter((x) => {
              return x.IsReaction;
          });
          this.movieDetails.tag_string = tags.data.map((x) => x.Tag).join(", ");
          //   .join(", ")):" da solo";
          return api.director.getByMovie(row.Ext_show.Movie_id);
        })
        .then((dirs) => {
          this.movieDetails.directors_string = dirs.data
            .map((x) => x.Name)
            .join(", ");
          this.showMovieDetails = true;
           loading.close();
        });
    },
    select(row) {
      this.newItem = row;
    },
    onPageChange(page) {
      this.page = page;
      this.getData();
    },
   
  },
  
  data() {
    return {
      selectedRow: null,
      newItem: emptyVal,
      vShow: {},
      rowData: [],
      imdbData: [],
      selected: null,
      selectedTab: 0,
      imdbName: "",
      page: 1,
      perPage: 10,
      total: 0,
      filter: {},
      lovs: {},
      allLovs: {},
      showServices: false,
      showMovieDetails: false,
      movieDetails: { row: {}, tmdb: {} },
      filteredTags: [],
      filteredReactions: [],
      filteredFriends: [],
      columns: [
        {
          field: "Id",
          label: "Id",
          width: "40",
          numeric: true,
        },
        {
          field: "Full_title",
          label: "Titolo",
          searchable: true
        },
        {
          field: "Date_seen",
          label: "Data",
          width: "120px",
        },
        {
          field: "Full_mode",
          label: "Dettagli",
        },
        {
          field: "Dicks",
          label: "Voto",
          searchable: true
        },
      ],
    };
  },
  mounted() {
    if (this.$store.state.jumpId) {
      this.filter = {
        Id: this.$store.state.jumpId
      }
      this.$store.state.jumpId = null;
    }
    const loading = this.$buefy.loading.open();

      api.lovs().then((data)=>{
        
        this.buildActiveLovs(data.data);
        this.getTotal();
        this.getData();
        loading.close();
      });
  },
};
</script>

<style>
.tagsection {
  margin-bottom: 5px;
}
</style>
